import React, { useState, useEffect } from "react";
import Image from "next/image";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useRouter } from "next/router";
import { fetchUserAttributes } from "aws-amplify/auth";
import ContentLayoutFooterNoChartreuse from "../components/Layout/ContentLayoutFooterNoChartreuse";

function Gifts() {
  const router = useRouter();
  const [userEmail, setUserEmail] = useState("");
  const { authStatus, user } = useAuthenticator((context) => [
    context.authStatus,
    context.user,
  ]);

  async function handleFetchUserAttributesEmail() {
    try {
      const userAttributes = await fetchUserAttributes();
      setUserEmail(userAttributes.email);
      return userAttributes.email;
    } catch (error) {
      console.log(error);
      return "";
    }
  }

  useEffect(() => {
    if (authStatus === "authenticated" && user) {
      handleFetchUserAttributesEmail();
    }
  }, [authStatus, user, router, userEmail]);

  const encodedEmail = encodeURIComponent(userEmail);

  return (
    <ContentLayoutFooterNoChartreuse title="Credits">
      <div className="w-full flex md:flex-row flex-col justify-center items-center">
        <Image
          src="/giftcard.png"
          alt="Gift Card"
          className="w-3/4 md:w-1/2 m-2 md:m-8"
          width={500}
          height={500}
        />
        <div className="w-3/4 md:1/2 m-2 md:m-8 relative flex flex-col justify-center items-center md:mb-8 mb-16">
          <h1 className="py-4 flex text-center text-4xl">
            Give the Gift of Custom Art
          </h1>
          <p className="mb-4 flex justify-start">
            Send a Raraity digital gift card to inspire a friend, colleague,
            customer or loved one to unlock their world of creativity.
          </p>
          <p className=" flex justify-start">
            Create, mount, and frame wall art with museum quality details using
            the Raraity platform.
          </p>
        </div>
      </div>
      <div className="relative flex flex-col justify-center items-center md:mb-8 mb-16">
        <h1 className="py-2">Choose Amount</h1>
        <div className="flex flex-wrap justify-center max-w-sm mb-24">
          <button
            type="button"
            className="text-md bg-black m-1 rounded-md py-3 px-2 w-20 flex items-center justify-center text-white border border-black cursor-pointer"
            onClick={() => {
              if (authStatus === "unauthenticated") {
                router.push("/login");
              } else {
                window.location.href = `https://checkout.raraity.com/b/4gw4hR04m87y1NK4gk?prefilled_email=${encodedEmail}`;
              }
            }}
          >
            $25
          </button>
          <button
            type="button"
            className="text-md bg-black m-1 rounded-md py-3 px-2 w-20 flex items-center justify-center text-white border border-black cursor-pointer"
            onClick={() => {
              if (authStatus === "unauthenticated") {
                router.push("/login");
              } else {
                window.location.href = `https://checkout.raraity.com/b/8wMg0z2cu0F64ZW4gl?prefilled_email=${encodedEmail}`;
              }
            }}
          >
            $50
          </button>
          <button
            type="button"
            className="text-md bg-black m-1 rounded-md py-3 px-2 w-20 flex items-center justify-center text-white border border-black cursor-pointer"
            onClick={() => {
              if (authStatus === "unauthenticated") {
                router.push("/login");
              } else {
                window.location.href = `https://checkout.raraity.com/b/eVa6pZcR8drS640006?prefilled_email=${encodedEmail}`;
              }
            }}
          >
            $75
          </button>
          <button
            type="button"
            className="text-md bg-black m-1 rounded-md py-3 px-2 w-20 flex items-center justify-center text-white border border-black cursor-pointer"
            onClick={() => {
              if (authStatus === "unauthenticated") {
                router.push("/login");
              } else {
                window.location.href = `https://checkout.raraity.com/b/4gw01B04m73ubok8ww?prefilled_email=${encodedEmail}`;
              }
            }}
          >
            $100
          </button>
          <button
            type="button"
            className="text-md bg-black m-1 rounded-md py-3 px-2 w-20 flex items-center justify-center text-white border border-black cursor-pointer"
            onClick={() => {
              if (authStatus === "unauthenticated") {
                router.push("/login");
              } else {
                window.location.href = `https://checkout.raraity.com/b/cN2cOneZg73udwsbIP?prefilled_email=${encodedEmail}`;
              }
            }}
          >
            $125
          </button>
          <button
            type="button"
            className="text-md bg-black m-1 rounded-md py-3 px-2 w-20 flex items-center justify-center text-white border border-black cursor-pointer"
            onClick={() => {
              if (authStatus === "unauthenticated") {
                router.push("/login");
              } else {
                window.location.href = `https://checkout.raraity.com/b/5kA5lV4kC87y9gc7sA?prefilled_email=${encodedEmail}`;
              }
            }}
          >
            $150
          </button>
          <button
            type="button"
            className="text-md bg-black m-1 rounded-md py-3 px-2 w-20 flex items-center justify-center text-white border border-black cursor-pointer"
            onClick={() => {
              if (authStatus === "unauthenticated") {
                router.push("/login");
              } else {
                window.location.href = `https://checkout.raraity.com/b/aEU29J5oG2Ne9gc9AB?prefilled_email=${encodedEmail}`;
              }
            }}
          >
            $200
          </button>
          <button
            type="button"
            className="text-md bg-black m-1 rounded-md py-3 px-2 w-20 flex items-center justify-center text-white border border-black cursor-pointer"
            onClick={() => {
              if (authStatus === "unauthenticated") {
                router.push("/login");
              } else {
                window.location.href = `https://checkout.raraity.com/b/bIYeWv3gy73uakg8wz?prefilled_email=${encodedEmail}`;
              }
            }}
          >
            Custom
          </button>
        </div>
      </div>
    </ContentLayoutFooterNoChartreuse>
  );
}

export default Gifts;

export async function getStaticProps() {
  return {
    props: { page: "Gifts" },
  };
}
